import { useEffect, useState } from "react";
import { BrandMark, ChevronDownIcon, MenuIcon } from "./icons.jsx";

const NAV = [
  { href: "/results/", label: "Stays" },
  { href: "/oahu/", label: "Islands", menu: [
    { href: "/oahu/", label: "Oʻahu" },
    { href: "/maui/", label: "Maui" },
    { href: "/kauai/", label: "Kauaʻi" },
    { href: "/big-island/", label: "Hawaiʻi Island" },
    { href: "/molokai/", label: "Molokaʻi" },
    { href: "/lanai/", label: "Lānaʻi" }
  ]},
  { href: "/edit/", label: "The Edit" },
  { href: "/about/", label: "Our Story" }
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <header className={`sticky top-0 z-50 transition ${scrolled ? "bg-white/95 shadow-[0_1px_0_rgba(15,40,60,0.06)] backdrop-blur" : "bg-transparent"}`}>
      <div className="container-page flex h-20 items-center justify-between gap-6">
        <a href="/" className="flex items-center">
          <img src="https://home.aloharates.com/home_page/Untitled%20-%20December%2010%2C%202025%20at%2016.40.27%C2%A0(1).png" alt="Aloha Rates" className="h-10 w-auto"/>
        </a>
        <nav className="hidden md:flex items-center gap-1">
          {NAV.map(item => (
            <div key={item.label} className="group relative">
              <a href={item.href} className="rounded-pill px-4 py-2 text-sm font-medium text-ink hover:bg-ink/5 inline-flex items-center gap-1">
                {item.label}
                {item.menu && <ChevronDownIcon size={12}/>}
              </a>
              {item.menu && (
                <div className="absolute left-1/2 top-full min-w-[220px] -translate-x-1/2 pt-2 opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto group-focus-within:opacity-100 group-focus-within:pointer-events-auto transition">
                  <div className="rounded-2xl border border-ink/5 bg-white p-2 shadow-cardHover">
                    {item.menu.map(sub => (
                      <a key={sub.href} href={sub.href} className="block rounded-lg px-3 py-2 text-sm text-ink hover:bg-sand-50 hover:text-ocean-700">{sub.label}</a>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          <a href="/booking/" className="rounded-pill px-4 py-2 text-sm font-medium text-ink hover:bg-ink/5">My booking</a>
          <a href="/results/" className="btn-primary">Search stays</a>
        </div>
        <button type="button" className="md:hidden inline-flex h-11 w-11 items-center justify-center rounded-pill border border-ink/10 bg-white text-ink" aria-label="Open menu" onClick={() => setOpen(v => !v)}>
          <MenuIcon size={20}/>
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-ink/5 bg-white">
          <div className="container-page flex flex-col py-4">
            {NAV.map(item => <a key={item.label} href={item.href} className="rounded-lg px-3 py-3 text-base text-ink hover:bg-sand-50">{item.label}</a>)}
            <a href="/booking/" className="rounded-lg px-3 py-3 text-base text-ink hover:bg-sand-50">My booking</a>
            <a href="/results/" className="btn-primary mt-3">Search stays</a>
          </div>
        </div>
      )}
    </header>
  );
}
